/*
 * This is so a superUser can edit the bio of any grad
 * Need to get userId of Bio To Edit
 * <EditABio />
 *      <GetBioDataForMongoDB />
 * 
 *      <GetBioList /> was replaced by <GetBioListPartial />
 */
import React, { useCallback, useState }   from 'react'
import BioDropdown                        from '../Components/BioDropdown'
import { Container, Box, Grid }           from '@material-ui/core/'
import { userIdOfBioToEditAction }        from '../Redux/Actions'
import GetBioListPartial                  from '../Components/GetBioListPartial'
import { Redirect }                       from 'react-router-dom'
import SearchArray                        from '../Components/SearchArray'
import { store }                          from '../Redux/Store'
import Typography                         from '@material-ui/core/Typography'

const EditABio = () => {

    const [ bioList, setBioList ] = useState([])
    const [ redirectToEditOneBioPage, setRedirectToEditOneBioPage ] = useState(false)

    const getBioListPartial = useCallback((bioListFromDB) => {
        setBioList(bioListFromDB)
    }, [] )

    const getBiosToShow = (t) => {
        /* I don't think this actually gets used anymore */
    }

    const getSelectedBio = (userId) => {
        store.dispatch( userIdOfBioToEditAction(userId) )
        setRedirectToEditOneBioPage(true)
    }

    return (
        <Box style={{marginTop: '7rem'}}>
            { redirectToEditOneBioPage ? <Redirect to='/EditOneBioPage' /> : null }

            <GetBioListPartial getBioListPartial={getBioListPartial} />

            <Container>
                <Grid container justifyContent='center'>
                    <Grid item xs={12}>
                        <Typography variant='h4'>
                            Edit a Bio (SuperUsers Only)
                        </Typography>
                    </Grid>

                    <BioDropdown bioList={bioList} getSelectedBio={getSelectedBio} label="Select A Bio to Edit" />
                    <SearchArray getStuffToShow={getBiosToShow} list={bioList}/>


                </Grid>
            </Container>
        </Box>
    )
}

export default EditABio
